import { Box, Flex, LegacyText } from "flicket-ui";
import { TicketExchangeAccordion } from "../../TicketExchangeAccordion";
import { TicketExchangeSectionProps } from "../types";

/**
 * Component to display ticket exchange information
 */
export const TicketExchangeSection = ({
  isExchangeFlow,
  ticketsLoading,
  hasTickets,
  ownedTicketData,
  ownedTicketsExchangeValue,
}: TicketExchangeSectionProps) => {
  if (!isExchangeFlow) return null;

  return (
    <>
      {ticketsLoading ? (
        <Box width="100%" borderBottom="1px solid" borderBottomColor="N100">
          <Flex alignItems="center" mb={2}>
            <LegacyText fontSize={2} fontWeight="bold">
              Loading ticket information...
            </LegacyText>
          </Flex>
        </Box>
      ) : (
        hasTickets && (
          <TicketExchangeAccordion
            tickets={ownedTicketData.getTicketsByIds}
            ticketValue={ownedTicketsExchangeValue}
            isLoading={false}
          />
        )
      )}
    </>
  );
};
